import clsx from 'clsx';

import { ArticleExperts, Persons } from 'types/studio/studio';

import { Typography } from '@ag1/ui';

import { StudioBaseImageV2 } from 'shared/studio/StudioBaseImage/StudioBaseImage';
import { CustomPortableText } from 'shared/studio/PortableText';

import styles from './EduArticlesExperts.module.scss';

const PersonItem = ({ image, name, title, description }: Persons) => (
  <div className={styles.expert}>
    {image && <StudioBaseImageV2 image={image} aspectRatio={1} className={styles.avatar} />}
    <div className={styles.expertHeadline}>
      <h3 className={clsx(styles.expertTitle, styles.expertName)}>{name}</h3>
      <h3 className={styles.expertTitle}>{title}</h3>
    </div>
    {description && <CustomPortableText value={description} className={styles.description} />}
  </div>
);

export const EduArticlesExperts = ({ title, writer, reviewer }: ArticleExperts) => (
  <div className={styles.wrapper}>
    <Typography variant="headline" size="2" noPadding className={styles.title}>
      {title}
    </Typography>
    {writer && <PersonItem {...writer} />}
    {reviewer && <PersonItem {...reviewer} />}
  </div>
);
